// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"io-z","outfitFeedbackSection":"jo-z"};